import React from 'react';
import './Products.css'
import Card from '../../shared/components/UIElements/Card';

function CustomTape() {
  return (
    <Card className='zipper-container'>
      <div className='zipper-element'>
        <img src="/custom_tape.jpg" alt="st sign"/>
      </div>
      <div className='zipper-text'>
        <h2>Custom Tape</h2>
        <p>Zipper tape is the third component of the “ZIPPER TRIAD” (Slider/Element/Tape). 
           Customized tape configurations are available to further compliment your design concept which helps to set your garment apart from others in the marketplace.  
          Whether it’s contrasting color teeth, embroidered design or creative use of textured thread, AGH Design Services can help “singularize” your garments fastener appearance maximizing sales and identification.</p>
      </div>
    </Card>
  )
}



export default CustomTape;